declare var _FROM_MOVIL: boolean;

const actionPageWorker = new Worker(new URL('./action_page.worker.ts', import.meta.url));

function sendVisit(type: string) {
	const user = getCookie('ualk');
	const session = getCookie('PHPSESSID');
	const page = window.location.origin + window.location.pathname;

	if (!user || !session || !type || !page) return;

	const visitData: any = {
		user,
		session,
		refdata: getCookie('refdata') || '',
		isMovil: _FROM_MOVIL || false,
		page,
		type
	};

	actionPageWorker.onmessage = (event: any) => {
		//console.info('sendVisit', event.data);
	};

	actionPageWorker.postMessage(visitData);
}


function getCookie(name: string): string | null {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null;
}

// Función para iniciar la sesión
function initVisit() {
	sendVisit('start');
}

// Función para finalizar la sesión y enviar los datos
function endVisit() {
	sendVisit('end');
}

// Activar si no es widget - ejecutar solo una vez por sesión
if (!window.location.pathname.includes('widget')) {
	if (!sessionStorage.getItem('alk_visit_initialized')) {
		sessionStorage.setItem('alk_visit_initialized', 'true');
		initVisit();
		window.addEventListener('beforeunload', endVisit);
	}
}
